import { actions } from "../../actions/action-list";
import initialState from "./initialState";

function Auth(state = initialState, action = {}) {
  switch (action.type) {
    case actions.TOKEN_EXPIRE:
      return { ...state, isTokenExpired: action.value };
    case actions.UPDATE_AUTHORITIES:
      return { ...state, authorities: action.value };
    case actions.UPDATE_USER:
      return { ...state, user: action.value };
    case actions.MENU_TYPE:
      return { ...state, selectedMenu: action.value };
    default:
      return state;
  }
}
export default Auth;
